export const PAGE_PATH = '/account-update';
